import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Badge, Carousel, notification } from "antd";
import { FaStar, FaPhoneSquare, FaStarHalfAlt, FaThumbsUp, FaWhatsapp, FaRegHeart, FaHeart } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import { getAllBusiness } from "../../../utils/API";
import { Link, useLocation, useNavigate } from "react-router-dom";
import verifiedlogo from "../../../assets/frontendassets/Verification Icons/1.png";
import trustLogo from "../../../assets/frontendassets/Verification Icons/3.png";
import trustedLogo from "../../../assets/frontendassets/Verification Icons/2.png";
import { Dropdown, Menu } from 'antd';
import { FaChevronDown } from 'react-icons/fa';
import { BiPhoneCall } from "react-icons/bi";
import { AuthContext } from "../../Auth/AuthContext";
// import "./LatestListing.css";
import './LatestListing.module.css';
import { detectCountryCodeForHome } from "../../../utils/setting";
const LatestListing = () => {
  const [businessData, setBusinessData] = useState<any[]>([]);
  const imageUrl = process.env.REACT_APP_IMAGE_URL + '/businesse/';
  const [slidesToShow, setSlidesToShow] = useState(3);
  const navigate = useNavigate();
  const [verifiedFilter, setVerifiedFilter] = useState(false);
  const [trustedFilter, setTrustedFilter] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0); // Start with the middle business as active by default
  const [wishlist, setWishlist] = useState<any>([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const country = searchParams.get("country");
  const [selectedCountry, setSelectedCountry] = useState<any>(country || null);
  const currentLocation = useLocation();
  const { authData } = useContext(AuthContext);
  const isLoggedIn = authData?.token;
  // This function will handle the slide change event
  interface Business {
    createdAt: string;
    _id: string;
    // or Date if it's a Date object
    // other properties...
  }
  const handleSlideChange = (current: number, next: number) => {
    if (next > current) {
      // Moving forward: highlight the next business
      setActiveIndex(next);
    } else if (next < current) {
      // Moving backward: highlight the previous business
      setActiveIndex(next);
    }
  };

  useEffect(() => {
    const fetchCountryCode = async () => {
      const countryName = await detectCountryCodeForHome(); // Get country name
      setSelectedCountry(countryName);
      console.log("Detected Country:", countryName);
    };
    fetchCountryCode();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setSlidesToShow(4);
      } else if (window.innerWidth > 768) {
        setSlidesToShow(3);
      } else if (window.innerWidth == 768) {
        setSlidesToShow(2);
      } else if (window.innerWidth > 435) {
        setSlidesToShow(1);
      }
      else {
        setSlidesToShow(1);
      }
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    if (selectedCountry) {
      handleGetBusiness();
    }
  }, [selectedCountry]);

  const handleGetBusiness = async () => {
    try {
      const res = await getAllBusiness("", "", "" , "","" , "" ,"" , "", selectedCountry);
      console.log("res", res);
      const filteredData = res.data.filter((item: any) => item.isHome === 1).reverse().slice(0, 6);
      console.log("filteredData", filteredData);
      setBusinessData(filteredData);
    } catch (error) {
      console.error("Failed to fetch business data", error);
    }
  };

  const filterBusinessData = (data: any) => {
    return data.filter((business: any) => {
      if (verifiedFilter && business.isVerified !== 2) return false;
      if (trustedFilter && business.isTrusted !== 2) return false;
      return true;
    });
  };

  const handleNavigate = (slug: any) => {
    navigate(`/business/${slug}`);
  };

  const isBusinessOpen = (businessHours: any) => {
    const dayIndex = new Date().getDay(); // Get current day index (0 = Sunday, 1 = Monday, etc.)
    const daysMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const currentDayName = daysMap[dayIndex];
    const currentDay = businessHours.find((hour: any) => hour.name === currentDayName);

    if (currentDay && currentDay.selected) {
      const now = new Date();
      const currentTime = now.getHours() * 100 + now.getMinutes(); // Convert current time to 24-hour format

      const openTime = parseInt(currentDay.openTime.replace(":", ""), 10);
      const closeTime = parseInt(currentDay.closeTime.replace(":", ""), 10);

      return currentTime >= openTime && currentTime <= closeTime;
    }

    return false; // Default to closed if no matching day is found
  };



  useEffect(() => {
    // Load wishlist from local storage
    const savedWishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
    setWishlist(savedWishlist);
  }, []);

  useEffect(() => {
    // Save wishlist to local storage
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  const isInWishlist = (business: any) => {
    return wishlist.some((item: any) => item.slug === business.slug);
  };

  const handleAddToWishlist = (business: any) => {
    if (!isLoggedIn) {
      // Notify the user that they need to log in 
      notification.warning({
        message: "Login Required",

        description: "You must be logged in to save this to your wishlist.",
        placement: "topRight",
      });
      navigate("/login", { state: { from: currentLocation.pathname } }); // Redirect to login only if not logged in
      return;
    }

    // If the user is logged in, add to the wishlist
    setWishlist((prevWishlist: any) => [...prevWishlist, business]);
    notification.success({ message: "Business added to wishlist" });
  };


  const handleRemoveFromWishlist = (business: any) => {
    if (!isLoggedIn) {
      // Notify the user that they need to log in
      notification.warning({
        message: "Login Required",
        description: "You must be logged in to remove items from your wishlist.",
        placement: "top"
      });
      return; // Exit the function if not logged in
    }

    setWishlist((prevWishlist: any) =>
      prevWishlist.filter((item: any) => item.slug !== business.slug)
    );
  };
  const calculateBusinessAge = (createdAt: any) => {
    const createdDate = new Date(createdAt);
    const currentDate = new Date();
// console.log('createdDate',createdDate) 
    const diffYears = currentDate.getFullYear() - createdDate.getFullYear();
    const diffMonths =
      currentDate.getMonth() - createdDate.getMonth() +
      diffYears * 12;
// console.log('diffMonths',diffMonths)
    const years = Math.floor(diffMonths / 12);
    const months = diffMonths % 12;
    // console.log('gfgfgdg',years, months)
      return years > 0
        ? `${years} yrs${years > 1 ? "" : ""} ${months} mth${months > 1 ? "" : ""} in business`
        : `${months} mth ${months > 1 ? "" : ""} in business`;
    };
  // console.log('business.createdAt', business.createdAt)
  return (
    <>
    <Row className="md:pt-8 md:ps-8 xs:py-10 xxs:py-10 md:px-18 xs:p-2 xxs:p-2 xl:pt-18 xl:ps-18 xl:px-18 p-18 sm:pt-12 sm:ps-12 sm:px-12 bg-[#FFF8EC]" justify={"center"}>
           <Col span={24}>
             <div className="flex items-center justify-end">
               <p style={{ fontSize: "14px", letterSpacing: "1px" }} className="text-right pb-3 text-black">
                HANDPICKED PLACES
               </p>
               <hr className="w-32 border-t-2 border-gray-400 ml-2 mb-3 " />
             </div>
             <div className="flex items-center justify-end">
               <p className="text-right  text-3xl  text-black">
                 See Latest listings
               </p>
             </div>
           </Col>
         </Row>


      <div
        className={` bg-[#FFF8EC] ${activeIndex !== null && activeIndex ? 'lg:pl-12 lg:pr-12 md:pl-8 md:pr-8 ' : ' md:pl-8 md:pr-8  lg:pl-12 lg:pr-12'
          }`}
      >
          {businessData.length > 0 ? (
      <Carousel
      className={`${activeIndex !== null && activeIndex && 'custom-carousel' }`}
      infinite
      slidesToShow={slidesToShow}  // Show 3 slides
      draggable
      dots={false}
      autoplay
      autoplaySpeed={3000}
      beforeChange={(current, next) => handleSlideChange(current, next)}
    >
    
    
      
        {businessData.map((item: any, index: any) => {
             const isMiddleBusiness = activeIndex === index;
            return (
              <div key={index} className={`rounded overflow-visible  transition-transform duration-300 relative ${ // Added 'relative' to create a new stacking context
                isMiddleBusiness ? 'transform  scale-105 z-10 sm:pt-12 xs:pr-5 xs:pl-5 xs:pt-12 xxs:pr-5 xxs:pl-5 xxs:pt-12  sm:pl-3 sm:pr-5' : 'pt-[11.5rem] pl-3 pr-3 pb-4 transform translate-y-2 scale-100'
                }`}
              >
                <a href="#">
                  <div className="relative overflow-visible ">
                  <img className={`object-cover ${isMiddleBusiness ? 'w-full rounded-t-xl [500px]' : 'w-full rounded-t-xl h-[315px]'}`} src={imageUrl + item.galleryImage[0]} alt="Listing" style={{ height: "320px" }} onClick={() => handleNavigate(item.slug)}/>

                  </div>
                </a>
                <div className="p-4 md:pt-4 lg:pt-4 xl:pt-4 2xl:pt-4 bg-[#FFE8C2] shadow-md shadow-gray-950 rounded-b-xl">
                  <div className="flex justify-between items-center md:pt-0 lg:pt-0 xl:pt-0 2xl:pt-0">
                    <div className="flex items-center">
                      {/* <FaThumbsUp className="text-yel:low-500" size={20} /> */}
                      <p className="text-black  text-lg xl:text-[22px] hover:text-yellow-500 font-semibold cursor-pointer" onClick={() => handleNavigate(item.slug)}>
                        {item.businessName.length > 20
                          ? `${item.businessName.slice(0, 17)}...`
                          : item.businessName}

                      </p>
                    </div>
                    <div>

                      {isInWishlist(item) ? (
                        <FaHeart
                          className="text-yellow-500 cursor-pointer"
                          size={18}
                          onClick={() => handleRemoveFromWishlist(item)}
                        />
                      ) : (
                        <FaRegHeart
                          className="text-yellow-500 cursor-pointer"
                          size={18}
                          onClick={() => handleAddToWishlist(item)}
                        />
                      )}

                    </div>
                  </div>
                  <div className="flex flex-wrap items-center pt-2">
                    <span className="text-sm rounded-md pl-1 pr-1 tracking-widest bg-[#118601] text-white p-1 flex items-center">
                      <FaStar className="pr-1 text-yellow text-lg" />
                      <span className="text-[13px] font-semibold">
                        {item.averageRating != null ? parseFloat(item.averageRating).toFixed(1) : '0'}
                      </span>
                    </span>

                                 <div className="flex pl-2 items-center">
                  {/* {business.reviews.length} ratings  */}
<span className="ml-2 text-gray-700 font-medium">
  {item.reviews.length} ratings
</span>
</div>
                  </div>
                  <div className="flex items-center space-x-3 ms-2">
                    {item.isVerified === 2 ? (
                    <div className="flex items-center space-x-1 pt-2">
                      <img src={verifiedlogo} alt="logo" className="w-[27px] h-[27px]" />
                    </div>
                   ) : (
                    <>
                     <div className="w-[27px] h-[27px]" ></div>
                    </>
                   ) }
                    {item.isTrusted === 2 && ( 
                    <div className="flex items-center space-x-1 pt-2">
                      <img src={trustLogo} alt="logo" className="w-[27px] h-[27px]" />
                    </div>
                    )}
                    {item.isPhysicallyVerified === 1 && ( 
                    <div className="flex items-center space-x-1 pt-2">
                      <img src={trustedLogo} alt="logo" className="w-[27px] h-[27px]" />
                    </div>
                    )}
                      <div>
                          <div key={item._id}>

                            {/* <p>{calculateBusinessAge(item.createdAt)} </p> */}

                          </div>
                      </div>
                    {/* )} */}
                  </div>
                  <Row gutter={[16, 16]} >
                  <Col
                        xs={8}
                        sm={8}
                        md={7}
                        lg={7}
                        xl={6}
                        xxl={5}
                      className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 w-[7rem]"
                    >
                      <a href={`tel:${item.mobileNumber}`} target="_blank" rel="noopener noreferrer">
                        
                      <button
                        className="flex items-center justify-center space-x-1 px-1 py-1.5 rounded-md bg-[#118601] border-1 border-gray-900 text-white w-full text-md sm:text-md"
                      >
                        <BiPhoneCall className="text-[12px] hidden xl:block" color="white" fill="white" />
                        <span className="text-[12px]">call</span>
                      </button>
                      </a>
                    </Col>
                    <Col
                      xs={8}
                      sm={8}
                      md={12}
                      lg={10}
                      xl={11}
                      xxl={11}
                      className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 md:ml-1 md:mr-1 w-auto"
                    >
                      <Link to={`/business/${item.slug}`}>
                      <button
                        className="flex items-center justify-center space-x-2 px-2 py-1.5 rounded-md bg-[#FFE8C2] border-1 border-gray-900 text-black w-full text-md sm:text-md whitespace-nowrap"
                      // onClick={handleEnquiryRedirect}
                      >
                        <FaStar className="text-yellow  text-[12px]" />
                        <span className="truncate text-[12px]">Write Review</span>
                      </button>
                      </Link>
                    </Col>
                    <Col
                      xs={8}
                      sm={8}
                      md={7}
                      lg={7}
                      xl={6}
                      xxl={5}
                      className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 w-[7rem]"
                    >
                      <Link to={`https://wa.me/${item.whatsappNumber}?text=I'm interested in ${item.businessName}`} target="_blank" rel="noopener noreferrer">
                        
                      <button
                        className="flex items-center justify-center space-x-1 px-1 py-1.5 rounded-md bg-[#FFE8C2] border-1 border-gray-900 text-gray-700 w-full text-md sm:text-md"
                      >
                        <FaWhatsapp className="text-[12px]" color="green" fill="green" />
                        <span className="text-[12px]">Chat</span>
                      </button>
                      </Link>
                    </Col>
                  </Row>
                  <p className="font-bold text-[14px] pt-[8px] ">Address</p>
                  <div className="flex items-center pt-[2px ] pb-[2px]">
  {/* <EnvironmentOutlined size={20} className="pr-2 text-yellow-500" /> */}
  <p
    className="hover:text-black whitespace-nowrap text-sm overflow-hidden"
    style={{
      lineHeight: '1.5rem', // Adjust line height for readability
      textOverflow: 'ellipsis', // Add ellipsis if content overflows
      whiteSpace: 'nowrap', // Prevent wrapping of text into multiple lines
    }}
  >
    {`${item.buildingName}, ${item.streetName}, ${item.city}, ${item.state}, ${item.pincode}`}
  </p>
</div>

                </div>
                {isMiddleBusiness && (
                  <div className="flex items-center justify-center space-x-3 ms-2 mt-4">
                    <div className="h-3 w-3 bg-[#757574] rounded-full"></div>
                    <div className="h-3 w-3 bg-[#757574] rounded-full"></div>
                    <div className="h-3 w-3 bg-[#757574] rounded-full"></div>
                  </div>

                )}

              </div>



            )
          })}
        </Carousel>
          ) : (
            <>
              <div className="">
                  No Business Found
              </div>
            </>
          )
        }
      </div>
    </>
  );
};

export default LatestListing;
